__webpack_require__.p = "/mixpanel-events-bx1crn/onboarding/";